import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/ReduxHooks";
import AddOrganizationModal from "../../UI/add-organization-modal/AddOrganizationModal";
import { getAllOrganizations } from "../../../redux/requests/AdminRequests";
import useOutsideAlerter from "../../../hooks/UseOutSide";

const Organization = () => {
  const organizations = useAppSelector((state) => state.admin.organizations);
  const dispatch = useAppDispatch();

  const { isShow, setIsShow, modalRef } = useOutsideAlerter(false);

  useEffect(() => {
    dispatch(getAllOrganizations());
  }, []);

  return (
    <div className="flex flex-col">
      <button
        className="text-white bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none self-end"
        onClick={() => setIsShow(true)}
      >
        Добавить
      </button>
      <div className="relative overflow-x-auto bg-neutral-primary-soft shadow-xs rounded-base border border-default">
        <table className="w-full text-sm text-left rtl:text-right text-body">
          <thead className="bg-neutral-secondary-soft border-b border-default">
            <tr>
              <th scope="col" className="px-6 py-3 font-medium">
                ID
              </th>
              <th scope="col" className="px-6 py-3 font-medium">
                name
              </th>
              <th scope="col" className="px-6 py-3 font-medium">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {organizations.map((org, index) => {
              return (
                <tr
                  className="odd:bg-neutral-primary even:bg-neutral-secondary-soft border-b border-default"
                  key={index}
                >
                  <td className="px-6 py-4">{org.id}</td>
                  <td className="px-6 py-4">{org.name}</td>
                  <td className="px-6 py-4">
                    <a
                      href="#"
                      className="font-medium text-fg-brand hover:underline"
                    >
                      Edit
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <AddOrganizationModal
        isActive={isShow}
        setIsActive={setIsShow}
        ref={modalRef}
      />
    </div>
  );
};

export default Organization;
